import React, { Component } from 'react'
import { Input } from 'antd'
import FormItem from './FormItem'

const { TextArea } = Input

class Text extends Component {

    render() {
        const { getFieldDecorator } = this.props.form

        return (
            <FormItem {...this.props}>
                {getFieldDecorator(this.props.attribute, this.props.fieldSettings)(
                    <TextArea size="large" disabled={this.props.disabled} onChange={this.props.handleChange} autosize={{ minRows: 10, maxRows: 100 }} />
                )}
            </FormItem>
        )
    }

}

export default Text


// WEBPACK FOOTER //
// ./src/inputs/Text.js